<template>
  <v-container id="user-profile" class="full-height-override" grid-list-xs>
    <h1 class="text-left mt-6 text--primary">Profile</h1>

    <v-row class="full-height-override">
      <v-col sm="3" cols="12">
        <v-list v-if="!isMobile" nav>
          <template v-for="(item, index) in nav">
            <v-list-item :key="index" :to="item.to" class="my-4 py-2">
              {{ item.title }}
            </v-list-item>
          </template>

          <v-footer v-if="!isMobile" color="white" class="pb-4 text-center">
            <h4 class="version mb-sm-4 my-3 font-weight-light">Version {{ appVersion }}</h4>
            <v-divider />
            <v-btn color="primary" class="my-sm-4 mt-3 text-center ma-auto" primary @click="logout">LOGOUT</v-btn>
          </v-footer>
        </v-list>

        <v-menu v-else offset-y>
          <template #activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on"> Menu </v-btn>
          </template>
          <v-list>
            <template v-for="(item, index) in nav">
              <v-list-item :key="index" :to="item.to" class="my-4 py-2">
                {{ item.title }}
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </v-col>
      <v-col sm="9" cols="12">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

export default Vue.extend({
  name: 'Profile',

  metaInfo: {
    title: 'Profile',
  },

  data() {
    return {
      nav: [
        {
          title: 'Personal information',
          // icon: 'mdi-home-outline',
          to: '/user/profile',
        },
        {
          title: 'Social',
          // icon: 'mdi-map-marker-distance',
          to: '/user/social',
        },
        {
          title: 'Communication',
          // icon: 'mdi-account-check-outline',
          to: '/user/communication',
        },
        {
          title: 'Support',
          // icon: 'mdi-map-marker',
          to: '/user/support',
        },
      ],
    }
  },

  computed: {
    ...mapGetters('app', ['appVersion']),
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
  },

  methods: {
    ...mapActions('auth', ['logout']),
  },
})
</script>

<style lang="scss" scoped>
.border-top {
  background-color: #ddd;
  height: 1px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

#user-profile {
  .v-list-item--active::before {
    opacity: 0;
  }

  .v-list {
    .v-list-item--active {
      color: #539fdb;
    }
  }

  .logo-wrapper {
    height: 90px;
  }
}

.version {
  width: 100%;
  text-align: center;
}

@media (min-width: 1904px) {
  .container {
    max-width: 1185px;
  }
}

@media (min-width: 960px) {
  .full-height-override {
    height: 100%;
  }

  #user-profile {
    position: relative;

    footer {
      position: absolute;
      bottom: 0;

      > h4 {
        justify-content: center;
        order: 0;
        width: 100%;
      }

      > button {
        justify-content: center;
        order: 0;
      }
    }
  }
}
</style>
